import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=e0b97f7c&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "./Info.vue?vue&type=style&index=0&id=e0b97f7c&scoped=true&lang=scss&"
import style1 from "./Info.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b97f7c",
  null
  
)

export default component.exports